module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mx-c7d5733d00f1645e1376edca902de410.svg";